<template>
    <div class="search">
        <div class="search__form">
            <button
                @click="searchNews"
                class="search__button"
                type="button">
            </button>
            <input
                v-model="fieldValue"
                :placeholder="placeholder"
                name="keywords"
                id="news_search"
                class="search__input"
                type="text"
                autocomplete="off"
                @keydown.enter.prevent="searchNews"
            >
        </div>
    </div>
</template>

<script>
    import { ref, computed, watch } from 'vue';
    import { useStore } from '../../store';
    import { search} from './services/search';

    export default {
        name: "pressSearch",
        props: {
            placeholder: { 
                default: '',
                type: String
            }
        },
        setup() {
            let fieldValue = ref('');

            const store = useStore();

            let pageNumber = computed(() => {
                return store.state.press.pageNumber;
            });

            let searchValue = computed(() => {
                return store.state.press.searchValue;
            });

            const searchNews = () => {
                search();
            }

            watch(fieldValue , (val) => {
                store.commit('press/SET_SEARCH_VAL', val);
            });

            watch(searchValue , (val) => {
                fieldValue.value = val;
            });

            return {
                fieldValue,
                pageNumber,
                searchValue,
                searchNews
            }
        }
    }
</script>

<style scoped lang="scss">
    .search__input:focus::placeholder {
        color: transparent;
    }
</style>
